<nb-card>
  <nb-card-header>
    <div class="logo-container">
      <a href="#"><img width="" alt="log" src="../../../../assets/images/logo-alternative.svg" href="#"></a>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-alert *ngIf="errors?.length && !submitted" outline="danger" role="alert">
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>

    <form (ngSubmit)="register()" #form="ngForm" aria-labelledby="title">
      <div class="form-control-group">
        <input nbInput [(ngModel)]="user.fullName" #fullName="ngModel" id="input-name" name="fullName"
          placeholder="Nome Completo" autofocus fullWidth fieldSize="large"
          [status]="fullName.dirty ? (fullName.invalid  ? 'danger' : 'success') : 'basic'" [required]="true"
          [minlength]="8" [maxlength]="256" [attr.aria-invalid]="fullName.invalid && fullName.touched ? true : null">
        <ng-container *ngIf="fullName.invalid && fullName.touched">
          <p class="caption status-danger" *ngIf="fullName.errors?.required">
            Este campo é obrigatório!
          </p>
          <p class="caption status-danger" *ngIf="fullName.errors?.minlength || fullName.errors?.maxlength">
            O nome deve contar
            de 8
            até 256
            caracteres.
          </p>
        </ng-container>
      </div>

      <div class="form-control-group">
        <input nbInput [(ngModel)]="user.email" #email="ngModel" id="input-email" name="email" pattern=".+@.+..+"
          placeholder="Email" fullWidth fieldSize="large"
          [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'" [required]="true"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null">
        <ng-container *ngIf="email.invalid && email.touched">
          <p class="caption status-danger" *ngIf="email.errors?.required">
            Este campo é obrigatório!
          </p>
          <p class="caption status-danger" *ngIf="email.errors?.pattern">
            É necessário um e-mail válido!
          </p>
        </ng-container>
      </div>

      <div class="form-control-group">
        <p class="caption">
          A senha deve ser de no mínimo 8
          caracteres (no mínimo uma letra maiúscula, letras minúsculas, números, e um caracter especial)
        </p>
        <input nbInput [(ngModel)]="user.password" #password="ngModel" type="password" id="input-password"
          name="password" placeholder="Senha" fullWidth fieldSize="large"
          [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : 'basic'" required="true"
          [minlength]="8" [attr.aria-invalid]="password.invalid && password.touched ? true : null">
        <ng-container *ngIf="password.invalid && password.touched">
          <p class="caption status-danger" *ngIf="password.errors?.required">
            Campo senha é obrigatório.
          </p>
          <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">
            A senha deve ser de no mínimo 8 caracteres (no mínimo uma letra maiúscula, letras minúsculas, números, e um
            caracter especial.)
          </p>
        </ng-container>
      </div>

      <div class="form-control-group">
        <input nbInput [(ngModel)]="user.confirmPassword" #confirmPassword="ngModel" type="password"
          id="input-re-password" name="confirmPassword" placeholder="Confirmar senha" fullWidth fieldSize="large"
          [status]="confirmPassword.dirty ? (confirmPassword.invalid || password.value != confirmPassword.value  ? 'danger' : 'success') : 'basic'"
          required="true" [attr.aria-invalid]="confirmPassword.invalid && confirmPassword.touched ? true : null">
        <ng-container *ngIf="confirmPassword.invalid && confirmPassword.touched">
          <p class="caption status-danger" *ngIf="confirmPassword.errors?.required">
            Campo confirmar senha é obrigatório!
          </p>
          <p class="caption status-danger" *ngIf="confirmPassword !== password">
            A senha não confere.
          </p>
        </ng-container>
      </div>

      <button nbButton fullWidth status="primary" size="large"
        [disabled]="submitted || !form.valid || (user.confirmPassword !== user.password)" [nbSpinner]="loading"
        nbSpinnerStatus="primary" nbSpinnerSize="large" nbSpinnerMessage="" [class.btn-pulse]="submitted">
        Inscrever-se
      </button>
    </form>

    <section *ngIf="socialLinks && socialLinks.length > 0" class="links" aria-label="Social sign in">
      ou acesse com:
      <div class="socials">
        <ng-container *ngFor="let socialLink of socialLinks">
          <a *ngIf="socialLink.link" [routerLink]="socialLink.link" [attr.target]="socialLink.target"
            [attr.class]="socialLink.icon" [class.with-icon]="socialLink.icon">
            <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
            <ng-template #title>{{ socialLink.title }}</ng-template>
          </a>
          <a *ngIf="socialLink.url" [attr.href]="socialLink.url" [attr.target]="socialLink.target"
            [attr.class]="socialLink.icon" [class.with-icon]="socialLink.icon">
            <nb-icon *ngIf="socialLink.icon; else title" [icon]="socialLink.icon"></nb-icon>
            <ng-template #title>{{ socialLink.title }}</ng-template>
          </a>
        </ng-container>
      </div>
    </section>
  </nb-card-body>
  <nb-card-footer>
    <section class="another-action" aria-label="Sign in">
      Já é cliente? <a class="text-link" routerLink="../login">Login</a>
    </section>
  </nb-card-footer>
</nb-card>